﻿module.exports = {
    strategy: 'Percentage',
    rules: [
        {
            taxValue: 15,
            minApplyAmount: 1000.00,
            minApplyAmountInclude: true
        }
    ]
};